import { useState, useEffect, useContext, useRef } from 'react';

import { inquiryHelpSearchContext } from '../InquiryHelpSearchContext';
import InquiryHelpSearchAidItem from './item/InquiryHelpSearchAidItem';
import Loading from '../../../../common/loading/Loading';

import { InquiryHelpModel } from '../../../../../models/inquiry/InquiryHelpModel';

function InquiryHelpSearchAid() {

  const {
    isLoading, inquiryHelpList
  } = useContext(inquiryHelpSearchContext);

  const [windowheight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    // 画面サイズ変更
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  return (
    <div style={{
      position: 'absolute',
      zIndex: 1,
      left: '5%',
      width: '90%',
      maxHeight: windowheight/2,
      overflow: 'auto', //スクロール可
      backgroundColor: '#f9f9f9',
      border: '1px solid #ccc',
      padding: '0 10px',
    }}>
      <>
      {isLoading ?
        <>
          <Loading />
        </>
      :
        <>
          {(inquiryHelpList && inquiryHelpList.length>0) ?
            inquiryHelpList.map((item: InquiryHelpModel) => (
              <InquiryHelpSearchAidItem
                key={item.id}
                inquiryHelpInfo={item}
              />
            ))
          :
            <p
              className='text-center'
              style={{margin: '5px 0'}}
            >該当するよくあるご質問は見つかりませんでした。</p>
          }
        </>
      }
      </>
    </div>
  );
}
  
export default InquiryHelpSearchAid;